import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AjouterComponent } from './ajouter/ajouter.component';
import { ConnecterComponent } from './connecter/connecter.component';
import { ModifierComponent } from './modifier/modifier.component';
import { AccueiladminComponent } from './accueiladmin/accueiladmin.component';
import { AccueilemployeComponent } from './accueilemploye/accueilemploye.component';
import { SupprimerComponent } from './supprimer/supprimer.component';
import { ChercherComponent } from './chercher/chercher.component';
import { ConsulterComponent } from './consulter/consulter.component';
import { ChercheremployeComponent } from './chercheremploye/chercheremploye.component';
import { ConsulteremployeComponent } from './consulteremploye/consulteremploye.component';


@NgModule({
  declarations: [
    AppComponent,
    AjouterComponent,
    ConnecterComponent,
    ModifierComponent,
    AccueiladminComponent,
    AccueilemployeComponent,
    SupprimerComponent,
    ChercherComponent,
    ConsulterComponent,
    ChercheremployeComponent,
    ConsulteremployeComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([
      {path: 'connecter', component: ConnecterComponent},
      {path: 'accueiladmin', component: AccueiladminComponent},
      {path: 'accueilemploye', component: AccueilemployeComponent},
      {path: 'ajouter', component: AjouterComponent},
      {path: 'modifier', component: ModifierComponent},
      {path: 'supprimer', component: SupprimerComponent},
      {path: 'chercher', component: ChercherComponent},
      {path: 'consulter', component: ConsulterComponent},
      {path: 'chercheremploye', component: ChercheremployeComponent},
      {path: 'consulteremploye', component: ConsulteremployeComponent},
    ]),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
